module.exports = __webpack_public_path__ + "media/site/images/icons/box-icon-3464fd9f36ddc73ab6562a1cd77a4b61.svg";